import { MediaMatcher } from '@angular/cdk/layout';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Objecttype, ObjecttypeCategory, ObjecttypeGroup, ObjecttypeSubgroup } from 'src/app/models/Objecttype';
import { AdminService } from 'src/app/services/admin.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-new-objecttype',
  templateUrl: './new-objecttype.component.html',
  styleUrls: ['./new-objecttype.component.css'],
})
export class NewObjecttypeComponent implements OnInit {
  private ngUnsubscribe = new Subject();

  Form = new UntypedFormGroup({
    // id: new FormControl('', [Validators.required]),
    name: new UntypedFormControl('', [Validators.required]),
    enName: new UntypedFormControl('', [Validators.required]),
    category: new UntypedFormControl('', [Validators.required]),
    group: new UntypedFormControl(''),
    subgroup: new UntypedFormControl(''),
  });
  error: string;

  // get id() {
  //   return this.Form.get('id');
  // }
  get name() {
    return this.Form.get('name');
  }
  get enName() {
    return this.Form.get('enName');
  }
  get category() {
    return this.Form.get('category');
  }
  get group() {
    return this.Form.get('group');
  }
  get subgroup() {
    return this.Form.get('subgroup');
  }

  objecttypeData: Objecttype;
  objecttypecategories: ObjecttypeCategory[] = [];
  groups: ObjecttypeGroup[] = [];
  subgroups: ObjecttypeSubgroup[] = [];

  mobileQuery: MediaQueryList;

  // Groups belonging to the currently selected category
  get availableGroups(): ObjecttypeGroup[] {
    const categoryid = this.category.value;
    if (!categoryid) {
      return [];
    }
    return this.groups.filter((g) => g.categoryid === categoryid);
  }

  // Subgroups belonging to the currently selected group
  get availableSubgroups(): ObjecttypeSubgroup[] {
    const groupid = this.group.value;
    if (!groupid) {
      return [];
    }
    return this.subgroups.filter((s) => s.groupid === groupid);
  }

  constructor(
    private dialogRef: MatDialogRef<NewObjecttypeComponent>,
    private adminservice: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    media: MediaMatcher,
    private snackbarservice: SnackbarService,
  ) {
    adminservice.getCategories().pipe(takeUntil(this.ngUnsubscribe)).subscribe((categories: ObjecttypeCategory[]) => {
      this.objecttypecategories = categories;
    });
    adminservice.getGroups().pipe(takeUntil(this.ngUnsubscribe)).subscribe((groups: ObjecttypeGroup[]) => {
      this.groups = groups;
    });
    adminservice.getSubgroups().pipe(takeUntil(this.ngUnsubscribe)).subscribe((subgroups: ObjecttypeSubgroup[]) => {
      this.subgroups = subgroups;
    });
    // Cascading reset: changing a parent clears the selections below it
    this.category.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.group.setValue('');
      this.subgroup.setValue('');
    });
    this.group.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.subgroup.setValue('');
    });
    this.mobileQuery = media.matchMedia(environment.mobileQueryMaxwidthSmall);
  }

  ngOnInit(): void {}

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }


  create(name: string, enName: string, categoryid: string, groupid?: string, subgroupid?: string) {
    // tslint:disable-next-line:prefer-const
    let category: ObjecttypeCategory = new ObjecttypeCategory();
    this.objecttypecategories.forEach((cat: ObjecttypeCategory) => {
      // const catid = cat.id.toString();
      if (cat.id === categoryid.toString()) {
        category = {
          id: cat.id,
          name: cat.name,
        };
      }
    });
    this.objecttypeData = {
      name,
      enName,
      category,
      active: true,
    };
    if (groupid) {
      const group = this.groups.find((g) => g.id === groupid);
      if (group) {
        this.objecttypeData.group = {id: group.id, name: group.name};
      }
    }
    if (subgroupid) {
      const subgroup = this.subgroups.find((s) => s.id === subgroupid);
      if (subgroup) {
        this.objecttypeData.subgroup = {id: subgroup.id, name: subgroup.name};
      }
    }
    this.adminservice.createObjecttype(this.objecttypeData);
    this.Form.reset();
    this.Form.markAsPristine();
    this.Form.markAsUntouched();
    this.dialogRef.close();
    this.snackbarservice.openSnackBar(
      'Objekttype opprettet: ' + this.objecttypeData.name,
      ''
    );
  }
}
